import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { Wallet, AlertTriangle, ChevronRight } from "lucide-react";
import { BALANCE_COLS, fmtNum } from "../pages/admin/balanceFields";

const Stat = ({ label, value, testid }) => (
  <div className="bg-[#f7f9fc] rounded-sm px-2 py-2 text-center">
    <div className="text-[17px] font-black text-[#16345c] leading-none tabular-nums" data-testid={testid}>{value}</div>
    <div className="text-[10.5px] text-gray-500 mt-1 leading-tight">{label}</div>
  </div>
);

const ferieTot = (r) => (r.ferie_balance || 0) + (r.prev_ferie_balance || 0);

export const AdminBalancesWidget = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/balances").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data) return null;

  const rows = data.rows || [];
  const sum = (fn) => rows.reduce((s, r) => s + fn(r), 0);
  const negatives = rows.filter((r) => BALANCE_COLS.some((c) => r[c.key] < 0)).length;
  const top = [...rows].sort((a, b) => ferieTot(b) - ferieTot(a)).filter((r) => ferieTot(r) > 0).slice(0, 3);

  return (
    <div className="mt-5 bg-white border border-gray-200 rounded-lg overflow-hidden" data-testid="home-balances">
      <div className="flex items-center gap-2 px-4 py-3 bg-gradient-to-r from-[#16345c] to-[#0d1b2f]">
        <Wallet size={16} className="text-white" />
        <h3 className="text-[13px] font-bold text-white flex-1">Saldi dipendenti</h3>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-3 gap-2">
          <Stat label="Dipendenti" value={rows.length} testid="home-balances-count" />
          <Stat label="Ferie residue (gg)" value={fmtNum(sum(ferieTot))} testid="home-balances-ferie" />
          <Stat label={`Straord. ${data.year} (h)`} value={fmtNum(sum((r) => r.overtime || 0))} testid="home-balances-ot" />
        </div>
        {negatives > 0 && (
          <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-800 text-[12px] px-3 py-2 rounded-sm mt-3" data-testid="home-balances-negative">
            <AlertTriangle size={14} className="shrink-0" /> {negatives} {negatives === 1 ? "dipendente ha" : "dipendenti hanno"} saldi negativi
          </div>
        )}
        {top.length > 0 && (
          <div className="mt-3">
            <div className="text-[11px] font-bold uppercase text-gray-400 mb-1.5">Più ferie da smaltire</div>
            <ul className="space-y-1" data-testid="home-balances-top">
              {top.map((r) => (
                <li key={r.id} className="flex items-center justify-between text-[12.5px]">
                  <span className="text-gray-600 truncate mr-2">{r.name}</span>
                  <b className="text-[#16345c] tabular-nums whitespace-nowrap">{fmtNum(ferieTot(r))} gg</b>
                </li>
              ))}
            </ul>
          </div>
        )}
        <button onClick={() => navigate("/admin?tab=balances")} data-testid="home-balances-open"
          className="group w-full mt-4 flex items-center justify-center gap-1 bg-[#16345c] hover:bg-[#0d1b2f] transition-colors text-white text-[13px] font-bold py-2.5 rounded-sm">
          Apri tabella saldi <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform" />
        </button>
      </div>
    </div>
  );
};
